import React from 'react';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import SendPushNotificationContainer from 'components/SendPushNotification';

const ScreenSendPushNotification = () => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={6}>
      <SendPushNotificationContainer />
    </GridItem>
  </GridContainer>
);

export default ScreenSendPushNotification;
